import { printHtmlSilently } from '../../lib/silentPrint';
// Imprime um comprovante de fiado 80mm na hora da venda a prazo,
// mostrando o valor lançado e o NOVO saldo devedor do cliente.
const fmt = (v) => `R$ ${Number(v || 0).toFixed(2).replace('.', ',')}`;

export function printFiadoVoucher({ company, customerName, saleNumber, creditAmount, newBalance, creditLimit }) {
  const now = new Date();
  const dateStr = now.toLocaleString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
  const trade = (company && company.trade_name) || 'Smart Flow';
  const addr = (company && company.address) || '';
  const phone = (company && company.phone) ? `Fone: ${company.phone}` : '';

  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Comprovante de Venda a Prazo</title>
    <style>
      @page { size: 80mm auto; margin: 2mm; }
      * { font-family: 'Courier New', monospace; }
      body { width: 76mm; font-size: 11px; color: #000; margin: 0; }
      h2 { text-align:center; font-size: 12px; margin: 4px 0; }
      .center { text-align:center; }
      .bold { font-weight: bold; }
      .divider { border-top: 1px dashed #000; margin: 5px 0; }
      .row { display:flex; justify-content:space-between; margin: 2px 0; }
      .big { font-size: 13px; }
      .box { border: 1px solid #000; padding: 4px; margin-top: 4px; text-align:center; }
      .sig { margin-top: 26px; border-top: 1px solid #000; text-align:center; font-size: 10px; padding-top: 2px; }
    </style></head><body>
    <h2>${trade}</h2>
    ${addr ? `<div class="center">${addr}</div>` : ''}
    ${phone ? `<div class="center">${phone}</div>` : ''}
    <div class="divider"></div>
    <div class="center bold big">COMPROVANTE DE VENDA A PRAZO</div>
    <div class="divider"></div>
    <div class="row"><span>Data:</span><span>${dateStr}</span></div>
    ${saleNumber ? `<div class="row"><span>Venda:</span><span>#${saleNumber}</span></div>` : ''}
    <div class="center">Cliente:</div>
    <div class="cust-name-big" style="font-size:18px;font-weight:bold;text-align:center;text-transform:uppercase">${(customerName || '-')}</div>
    <div class="divider"></div>
    <div class="row"><span>Valor lançado a prazo:</span><span class="bold">${fmt(creditAmount)}</span></div>
    ${Number(creditLimit) > 0 ? `<div class="row"><span>Limite de crédito:</span><span>${fmt(creditLimit)}</span></div>` : ''}
    <div class="box">
      <div class="bold">NOVO SALDO DEVEDOR</div>
      <div class="bold big">${fmt(newBalance)}</div>
    </div>
    <div class="divider"></div>
    <div class="sig">Assinatura do cliente</div>
    <div class="center" style="margin-top:6px;">Obrigado pela preferência!</div>
    </body></html>`;

  printHtmlSilently(html);
}
